import FontAwesome from '@expo/vector-icons/FontAwesome'
import { type ComponentProps } from 'react'
import { useThemeColors } from '@/contexts/ThemeContext'

type Props = {
  name: ComponentProps<typeof FontAwesome>['name']
  size?: number
  color?: string
}

export function Icon({ name, size = 16, color }: Props) {
  const colors = useThemeColors()
  return <FontAwesome name={name} size={size} color={color ?? colors.dark} />
}
